import IIcon from "interfaces/icon";

function NotificationUpArrow({ color = "#16B364" }: IIcon) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_601_12979" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_601_12979)">
        <path
          d="M17 8.4L6.10005 19.3C5.91672 19.4833 5.68338 19.575 5.40005 19.575C5.11672 19.575 4.88338 19.4833 4.70005 19.3C4.51672 19.1167 4.42505 18.8833 4.42505 18.6C4.42505 18.3167 4.51672 18.0833 4.70005 17.9L15.6 7H10C9.71672 7 9.47922 6.90417 9.28755 6.7125C9.09588 6.52083 9.00005 6.28333 9.00005 6C9.00005 5.71667 9.09588 5.47917 9.28755 5.2875C9.47922 5.09583 9.71672 5 10 5H18C18.2834 5 18.5209 5.09583 18.7125 5.2875C18.9042 5.47917 19 5.71667 19 6V14C19 14.2833 18.9042 14.5208 18.7125 14.7125C18.5209 14.9042 18.2834 15 18 15C17.7167 15 17.4792 14.9042 17.2875 14.7125C17.0959 14.5208 17 14.2833 17 14V8.4Z"
          fill={color}
        />
      </g>
    </svg>
  );
}

export default NotificationUpArrow;
